import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { FileListViewConfigFactory } from '../file-list-view/file-list-view-config.factory';
import { IFileListViewConfig } from '../file-list-view/file-list-view.component';
import { MergeBasketViewConfigFactory } from '../merge-basket-view/merge-basket-view-config.factory';
import { IMergeBasketViewConfig } from '../merge-basket-view/merge-basket-view.component';
import { ServiceProviderService } from '../services/service.provider.service';

export class MergeComponentConfig {
  fileListViewConfig: IFileListViewConfig;
  mergeBasketViewConfig: IMergeBasketViewConfig;

  constructor(
    namespace: string,
    serviceProviderService: ServiceProviderService,
    sharedServiceProviderServiceFactory: SharedServiceProviderServiceFactory
  ) {
    this.fileListViewConfig = FileListViewConfigFactory.create(namespace, serviceProviderService, sharedServiceProviderServiceFactory);
    this.mergeBasketViewConfig = MergeBasketViewConfigFactory.create(namespace, serviceProviderService, sharedServiceProviderServiceFactory);
  }
}
